export default __webpack_public_path__ + "static/media/happy.eccadebc.png";